import React, { useCallback, useEffect, useState } from "react";
import sbpService from "../../service/sbp.service";
import { forgetSteamOrder } from "./steam-order-storage";

export function recentOrderStatus(result) {
  if (!result?.success) return { text: "Не удалось проверить статус", canOpen: false };
  const { status, steamStatus, paymentRetry } = result;
  if (status === "SUCCESS") {
    if (steamStatus === "SUCCESS") return { text: "Steam пополнен", canOpen: false };
    if (steamStatus === "FAILED") {
      return {
        text: "Оплачен, но пополнить Steam не удалось. Напишите в поддержку и укажите номер заказа",
        canOpen: false,
        support: true,
      };
    }
    return { text: "Оплачен, пополняем Steam", canOpen: false };
  }
  if (status === "PENDING" || status === "PROCESSING") return { text: "Ожидает оплаты", canOpen: true };
  if (status === "FAILED") return { text: "Оплата не прошла", canOpen: Boolean(paymentRetry?.available) };
  if (status === "CANCELLED") return { text: "Оплата отменена", canOpen: false };
  return { text: "Не удалось проверить статус", canOpen: false };
}

async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const field = document.createElement("textarea");
  field.value = text;
  document.body.appendChild(field);
  field.select();
  document.execCommand("copy");
  document.body.removeChild(field);
}

const SteamRecentOrder = ({ order, onOpen, onHide }) => {
  const [state, setState] = useState(null);
  const [checking, setChecking] = useState(true);
  const [copied, setCopied] = useState(false);

  const refresh = useCallback(async () => {
    setChecking(true);
    const result = await sbpService.checkPaymentStatus(order.orderId);
    setState(recentOrderStatus(result));
    setChecking(false);
  }, [order.orderId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleCopy = async () => {
    try {
      await copyText(order.orderId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const handleHide = () => {
    forgetSteamOrder(order.orderId);
    onHide();
  };

  const payText = order.isCrypto ? `${order.cryptoAmount} USDT` : `${order.payAmount} ₽`;

  return (
    <div className="mb-4 rounded-lg border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 p-4 text-sm text-gray-700 dark:text-gray-300">
      <div className="flex items-center justify-between mb-2">
        <p className="font-semibold text-gray-900 dark:text-white">Ваш заказ</p>
        <button
          type="button"
          onClick={handleHide}
          className="text-xs text-gray-500 dark:text-gray-400 hover:underline"
        >
          Скрыть
        </button>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-2">
        <span className="font-mono break-all">{order.orderId}</span>
        <button
          type="button"
          onClick={handleCopy}
          className="text-xs text-blue-600 dark:text-blue-400 hover:underline"
        >
          {copied ? "Скопировано" : "Скопировать"}
        </button>
      </div>

      <p className="mb-1">
        <span className="font-medium">Steam аккаунт:</span> {order.steamAccount}
      </p>
      <p className="mb-1">
        <span className="font-medium">Получите в Steam:</span> {order.amountRUB} ₽
      </p>
      <p className="mb-1">
        <span className="font-medium">Сумма к оплате:</span> {payText}
      </p>
      <p className="mb-3">
        <span className="font-medium">Статус:</span>{" "}
        {checking ? "Проверяем…" : state?.text}
        {!checking && state?.support && (
          <>
            {" "}
            <a
              href={process.env.REACT_APP_SUPPORT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              @tp_trendy_eng_shop
            </a>
          </>
        )}
      </p>

      <div className="flex flex-wrap gap-2">
        {!checking && state?.canOpen && (
          <button
            type="button"
            onClick={() => onOpen(order)}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-1.5 px-3 rounded-md transition duration-200"
          >
            Открыть заказ
          </button>
        )}
        <button
          type="button"
          onClick={refresh}
          disabled={checking}
          className="border border-blue-600 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40 disabled:opacity-50 py-1.5 px-3 rounded-md transition duration-200"
        >
          Обновить статус
        </button>
        <button
          type="button"
          onClick={handleHide}
          className="border border-gray-400 dark:border-gray-500 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 py-1.5 px-3 rounded-md transition duration-200"
        >
          Отменить
        </button>
      </div>
    </div>
  );
};

export default SteamRecentOrder;
